import { Reducer } from 'redux';

import { AccountActionTypes, AccountState } from './types';

const defaultState: AccountState = {
    accountLoading: false,
    createAccountInProgress: false,
    resetPasswordSent: false,
    updatingOptions: [],
};
const reducer: Reducer<AccountState> = (state: AccountState = defaultState, action): AccountState => {
    const { payload } = action;

    switch (action.type) {
        case AccountActionTypes.UPDATE_MARKETING_OPTIONS_START:
            return { ...state, ...payload.account, ...{ marketingOptionsLoading: true } };
        case AccountActionTypes.UPDATE_MARKETING_OPTIONS_SUCCESS:
            return { ...state, ...payload.account, ...{ marketingOptionsLoading: false } };
        case AccountActionTypes.FETCH_START:
        case AccountActionTypes.FETCH_ERROR:
            return { ...state, ...{ accountLoading: payload.accountLoading } };
        case AccountActionTypes.FETCH_SUCCESS:
        case AccountActionTypes.UPDATE_SUCCESS:
            return { ...state, ...{ accountLoading: payload.accountLoading }, ...payload.account };
        case AccountActionTypes.UPLOAD_LOGO_START:
            return { ...state, ...{ uploadingLogo: true } };
        case AccountActionTypes.UPLOAD_LOGO_FINISH:
            return { ...state, ...{ uploadingLogo: false } };
        case AccountActionTypes.CREATE_ACCOUNT_SUCCESS:
            return { ...state, ...payload };
        case AccountActionTypes.VALIDATE_INPUT_SUCCESS:
            return { ...state, ...{ inputErrorName: '' } };
        case AccountActionTypes.VALIDATE_INPUT_ERROR:
            return { ...state, ...{ inputErrorName: payload.optionName } };
        case AccountActionTypes.CREATE_ACCOUNT:
        case AccountActionTypes.CREATE_ACCOUNT_WITH_GOOGLE:
            return { ...state, ...{ createAccountInProgress: true } };
        case AccountActionTypes.CREATE_ACCOUNT_ERROR:
            return { ...state, ...{ createAccountInProgress: false } };
        case AccountActionTypes.RESET_PASSWORD_START:
            return { ...state, ...{ resetPasswordInProgress: true } };
        case AccountActionTypes.RESET_PASSWORD_SUCCESS:
            return { ...state, ...{ resetPasswordSent: true, resetPasswordInProgress: false } };
        case AccountActionTypes.RESET_PASSWORD_ERROR:
            return { ...state, ...{ resetPasswordInProgress: false } };
        case AccountActionTypes.UPDATE_CRC_PARAM: {
            return { ...state, ...{ CRCForm: { ...state.CRCForm, ...payload.CRCParam } } };
        }
        case AccountActionTypes.GET_ACCOUNTS_NAME:
            return { ...state, ...{ subaccountEmail: payload.subaccountEmail, nameLoading: payload.nameLoading } };
        case AccountActionTypes.GET_ACCOUNTS_NAME_SUCCESS:
            return { ...state, ...{ CrcProfile: payload.CrcProfile, nameLoading: payload.nameLoading } };
        case AccountActionTypes.GET_ACCOUNTS_NAME_ERROR:
            return { ...state, ...{ nameLoading: payload.nameLoading } };
        case AccountActionTypes.GET_ACCOUNT_WARNINGS_SUCCESS:
            return { ...state, warnings: action.payload.warnings };
        case AccountActionTypes.UPDATE_CRC_STATUS_IN_ACCOUNT:
            return {
                ...state,
                GeneralInfo: {
                    ...state.GeneralInfo,
                    CrcStatus: action.payload.CrcStatus,
                },
            };
        case AccountActionTypes.GET_CUSTOM_BRANDING_SUCCESS:
            return {
                ...state,
                BrandingInfo: payload.brandingInfo,
                isBrandingInfoLoaded: true,
            };
        case AccountActionTypes.UPDATE_GENERAL_INFO:
            return {
                ...state,
                GeneralInfo: payload.GeneralInfo,
            };
        case AccountActionTypes.UPDATE_OVERVIEW_AI_TOOLS_TEXT_COUNT:
            return {
                ...state,
                Overview: { ...state.Overview, AIToolsTextCount: action.payload.count },
            };

        default:
            return state;
    }
};

export { reducer as account };

export default reducer;
